import './App.css';
import {useState, useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import CHT from './img/cht_logo.svg';
import Logo_CNC from './img/cnc_logo.svg';
import Logo_WFSS from './img/wfs_logo.svg';
import Logo_TC from './img/tc_logo.svg';
import Block_WFSS from './img/block_wfs.png';
import Block_CNC from './img/block_cnc.png';
import Block_TC from './img/block_tc.png';
import Block_E_CNC from './img/cnc_block_enterprise.jpg';
import {b_left, b_right} from './others';
import NoShow from './page/no_show/NoShow';

const setting = {
    D: {
        title: '色情守門員攔阻畫面',
        logo_src: Logo_WFSS,
        block_logo: Block_WFSS,
        service_protected: '色情守門員',
        protect_info: '您所前往的網頁已受控管',
        bl_text: '解除防護',
        br_text: '誤擋申訴',
    },
    W: {
        title: '防駭守門員攔阻畫面',
        logo_src: Logo_CNC,
        block_logo: Block_CNC,
        service_protected: '防駭守門員',
        protect_info: '所前往的網頁可能為危險網頁，建議您不要繼續前往',
        bl_text: '離開此網頁',
        br_text: '仍要前往',
    },
    T: {
        title: '上網時間管理攔阻畫面',
        logo_src: Logo_TC,
        block_logo: Block_TC,
        service_protected: '上網時間管理',
        protect_info: '目前為限制上網時段，讓眼睛休息一下吧',
        bl_text: '解除防護',
        br_text: '查詢上網時間',
    },
};
const DEFAULT_SERVICE = 'D';

const App = () => {
    const [isRendered, setIsRendered] = useState(false);
    const [curService, setCurService] = useState('');
    const [hexStr, setHexStr] = useState(''); // CNC url
    const [host, setHost] = useState(''); // CNC host
    const [renderEnterprise, setRenderEnterprise] = useState(false);

    const location = useLocation();

    const fetchDspAttr = (path, params) =>
        fetch(`/api/v1/dsp${path}/attr?${params.toString()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        }).then((response) => response.json());

    const blockTypeResult = (data, current_service) =>
        data.status === 1 && data.category === current_service && data.level === 2;

    useEffect(() => {
        const resetToDefault = (current_service) => {
            setIsRendered(true);
            setRenderEnterprise(false);
            document.title = setting[current_service]['title'];
        };

        const checkBlockStatus = async (current_service, did) => {
            try {
                const timestamp = new Date().getTime();
                const params = new URLSearchParams({timestamp, did, flag: current_service});
                if (current_service === 'W') {
                    const data = await fetchDspAttr('w', params);
                    const isEnterprise = blockTypeResult(data, current_service);
                    if (isEnterprise) {
                        setRenderEnterprise(true);
                        document.title = setting[current_service]['title'];
                    } else {
                        resetToDefault(current_service);
                    }
                } else if (current_service === 'T') {
                    const data = await fetchDspAttr('t', params);
                    const hideTCBlocked = blockTypeResult(data, current_service);
                    if (!hideTCBlocked) {
                        resetToDefault(current_service);
                    }
                } else {
                    resetToDefault(current_service);
                }
            } catch (error) {
                resetToDefault(current_service);
            }
        };

        let query_string = new URLSearchParams(location.search);
        let current_service = query_string.get('flag')
            ? query_string.get('flag').toUpperCase()
            : DEFAULT_SERVICE;
        let cur_uri = query_string.get('uri') ? query_string.get('uri') : '';
        let cur_host = query_string.get('host') ? query_string.get('host') : '';
        let did = query_string.get('did') ? query_string.get('did') : '';

        setCurService(current_service);

        if (current_service === 'W' && cur_uri.length > 0 && cur_host.length > 0) {
            // CNC 跳轉處理
            setHexStr(cur_uri);
            setHost(cur_host);
        }

        if (['T', 'W'].includes(current_service)) {
            checkBlockStatus(current_service, did);
        } else {
            resetToDefault(current_service);
        }
    }, [location, curService]);

    // 企業頁面渲染
    if (renderEnterprise) {
        return (
            <div className='enterprise_block'>
                <div className='enterprise_content'>
                    <img
                        src={Block_E_CNC}
                        alt='企業防駭守門員攔阻畫面'
                        className='enterprise_image'
                    />
                    <div className='enterprise_bottom'>
                        <button
                            className='enterprise_left_button'
                            onClick={() => b_left(curService)}>
                            回到上一頁
                        </button>
                        <button
                            className='enterprise_right_button'
                            onClick={() => b_right(curService, hexStr, host)}>
                            繼續前往
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    // 一般頁面渲染
    return isRendered && curService && setting[curService] ? (
        <div>
            <div className='content_block'>
                <div className='logos'>
                    <img src={CHT} alt={'CHT logo'} className={'l_logo'} width={153} height={50} />
                    <img
                        src={setting[curService]['logo_src']}
                        alt={`${curService.toUpperCase()} logo`}
                        className={'r_logo'}
                        width={215}
                        height={75.44}
                    />
                </div>
                <div className='service_detail'>
                    <div className='service_inner service_text'>
                        <div>
                            <img
                                className='service_logo'
                                alt={'service logo'}
                                src={setting[curService]['block_logo']}
                            />
                        </div>
                        <div className='text_box'>
                            <p className='outer_text top'>您的網路已啟動</p>
                            <p className='outer_text bottom'>
                                「{setting[curService]['service_protected']}」防護
                            </p>
                            <p className='inner_text'>{setting[curService]['protect_info']}</p>
                        </div>
                    </div>
                    <div className='service_inner'>
                        <button
                            className={`default b_left ${curService}`}
                            type={'button'}
                            onClick={() => b_left(curService)}>
                            {setting[curService]['bl_text']}
                        </button>
                        <button
                            className={`default b_right ${curService}`}
                            type={'button'}
                            onClick={() => b_right(curService, hexStr, host)}>
                            {setting[curService]['br_text']}
                        </button>
                    </div>
                </div>
            </div>
            <footer class='footer'>
                <div class='footer_box'>
                    <p class='footer_text'>中華電信股份有限公司版權所有</p>
                </div>
            </footer>
        </div>
    ) : (
        <NoShow />
    );
};

export default App;
